import React from "react"
import Paper from "../../ui/Paper"
import { useDispatch, useSelector } from "react-redux"
import { selectGenerating, updatePasses } from "./slice"
import LoadingSpinner, { Backdrop } from "../../ui/LoadingSpinner"
import styled from "styled-components"
import Label from "../../ui/Label"
import Select from "../../ui/Select"
import FormGroup from "../../ui/FormGroup"
import Button from "../../ui/Button"
import { useForm } from "react-hook-form"
import ErrorMsg from "../../ui/ErrorMsg"
import PropTypes from "prop-types"
import { slideFromRight } from "../../ui/animations"

const Panel = styled(Paper)`
  padding: 2rem;
  overflow-y: auto;
  width: 25vw;
  min-width: 20rem;
  max-width: 40rem;
  animation: 0.3s ${slideFromRight} ease-out;
`

const FormActions = styled.div`
  padding-top: 1rem;
`

const FormContainer = styled.div``

/**
 * Generate passes
 *
 * @param handleCancel
 * @returns {JSX.Element}
 * @constructor
 */
const GeneratePasses = ({ noradIds = [], handleCancel, handleComplete }) => {
  const dispatch = useDispatch()
  const inProgress = useSelector((state) => selectGenerating(state))
  const { register, handleSubmit } = useForm()

  const handleUpdatePasses = (data) => {
    // console.log(dateTimeProducer[data.period])
    // dateTimeProducer[data.period]
    // const currentDate = new Date() // Get the current datetime
    // const futureDate = new Date(currentDate.getTime()) // Create a copy of the current datetime
    // futureDate.setUTCDate(futureDate.getUTCDate() + 20) // Add 10 days to the future date in UTC
    dispatch(
      updatePasses({ norad_ids: noradIds, from: "now", to: data.period })
    ).then((data) => {
      if (!data?.error) {
        handleCancel()
      }
      handleComplete()
    })
  }

  return (
    <Panel>
      <h2>Generate passes</h2>
      {inProgress?._saveStatus === "updating" && (
        <Backdrop>
          <LoadingSpinner />
        </Backdrop>
      )}
      {inProgress?._saveStatus == "rejected" && (
        <ErrorMsg
          msg={
            inProgress._errorMessage || "an error occurred generating passes"
          }
          showIcon={true}
        />
      )}
      {noradIds && noradIds.length > 1 && (
        <p>{noradIds.length} selected RSOs</p>
      )}
      <FormContainer>
        <form onSubmit={handleSubmit(handleUpdatePasses)}>
          <FormGroup>
            <Label htmlFor="period">For next:</Label>
            <Select {...register("period")}>
              <option defaultValue={"p48h"} value="p48h">
                48 hours
              </option>
              <option value="p7d">1 week</option>
              <option value="p14d">2 weeks</option>
            </Select>
          </FormGroup>
          <FormActions>
            <Button type="submit">submit</Button>
            {handleCancel && <Button onClick={handleCancel}>close</Button>}
          </FormActions>
        </form>
      </FormContainer>
    </Panel>
  )
}

GeneratePasses.propTypes = {
  noradIds: PropTypes.array.isRequired, // the norad ids we want to regenerate
  handleCancel: PropTypes.func.isRequired, // Cancel passes regewnration
  handleComplete: PropTypes.func.isRequired, // Called after the action completes e.g. to refresh passes
}
export default GeneratePasses
